import { render, staticRenderFns } from "./admin_other_links.vue?vue&type=template&id=7946666c&scoped=true"
import script from "./admin_other_links.vue?vue&type=script&lang=js"
export * from "./admin_other_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7946666c",
  null
  
)

export default component.exports